import { createContext, useContext, useState } from "react";
import { flushSync } from "react-dom";
export const SectorContext = createContext(null);
export function SectorProvider({ children }) {
  // Sets and holds state for the selectedSector.
  const [selectedSector, setSelectedSector] = useState("cyber");

  const sectorData = {
    // CYBER DATA OBJECT
    cyber: {
      colorClass: "cyber-accent",
      // mainHeaderText: ["I BREAK THINGS SO", "ATTACKERS CANT"]  ,

      mainHeaderText: [
        {
          text: "I BREAK IT,",
          emphasized: false,
        },
        {
          text: " SO",
          emphasized: false,
        },

        {
          text: "ATTACKERS CAN'T.",
          emphasized: true,
        },
      ],

      headerImage: {
        src: "Cyberadj3.webp",
        alt: "Valentino Lloyd — Cybersecurity",
      },
      accentImage: { src: "sector-accents/CyberAccent.svg", alt: "lock" },
      mainHeaderSubtext:
        "As a penetration tester, I aspire to deliver value by identifying vulnerabilities, tracing realistic paths to compromise, and translating technical findings into practical security insights for decision makers.",
      bumperText: [
        "Cybersecurity is rarely the loudest or most visible part of a business, but it can be one of the most critical.",
        " It protects the systems, information, and processes through which the organization creates and delivers value.",
      ],
      contactContent: {
        contactHook: [
          "I THINK I CAN HELP WITH THAT",
          "Let's Strengthen The Systems Your Business Depends On.",
        ],
        contactHeader: "CONNECT WITH ME",

        contactDescription:
          "Whether its testing a network, or web app, the goal is always to make it more secure.",
      },
      // Cyber Projects Array
      projects: [
        {
          projName: "Ultratech",
          projHeadline: "An open endpoint closed the exploit.",
          projOverview:
            "Seemingly minor weaknesses across exposed services, authentication controls, and system configuration combined to enable full system compromise.",

          projClient: "Web, SQL, Linux",
          projSpecial: "TryHackMe Lab",
          projStory:
            "Initial enumeration revealed several disclosures which were used to strengthen an attack path. An initial foothold was obtained through exploiting command injection vulnerabilities within an API endpoint, and poor password management practices. Lateral movement and post exploit enumeration was achieved due to weak passwords and user authentication practices. This allowed us to identify several additional points of exposure, misconfiguration, vulnerability. Ultimately,  privilege escalation and full compromise was achieved through abuse of overly permissive group memberships and insufficient separation of privileges.",
          projRole: "Penetration Testing Consultant",
          projDuty:
            "Enumeration, Vulnerability Assessment, Exploitation, Remediation Research, Report writing.",
          projHeroImage: "ultraportal.webp",
          projImages: [
            "ultranmap.webp",
            "ultraportal.webp",
            "ultradbcrack.webp",
            "ultraexploit.webp",
          ],
          projDocuments: [
            {
              title: "THM Ultratech Pentest Report",
              type: "PDF",
              url: "/docs/UltratechUpdated.pdf",
            },
          ],
          projAwards: [],
        },

        {
          projName: "Biblioteca",
          projHeadline: "The privileged path  opened the door.",
          projOverview:
            "Broken access controls, weak authentication practices, and excessive privileges left this environment exposed.",
          projClient: "Web, Linux",
          projSpecial: "TryHackMe Lab",
          projStory:
            "External testing revealed several weaknesses including insufficient authentication controls, and a login portal that proved vulnerable to SQL injection. This allowed us to enumerate the database and exfiltrate credentials for a lower privileged account. This elevated access exposed additional opportunities for privilege escalation and ultimately full compromise of the host.",
          projRole: "Cybersecurity Consulant",
          projDuty:
            "Enumeration, Vulnerability Assessment, Exploitation, Remediation Research, Report writing.",
          projHeroImage: "bibliowebportal.webp",
          projImages: [
            "bibliowebportal.webp",
            "biblionetcat.webp",
            "biblionmap.webp",
            "bibliolateralmv.webp",
            "biblioroot.webp",
          ],
          projDocuments: [
            {
              title: "Biblioteca Pentest Report",
              type: "PDF",
              url: "/docs/Bibliotecareport.pdf",
            },
          ],
          projAwards: ["Cyber Award A", "Award B"],
        },
        {
          projName: "Forward",
          projHeadline: "A chain of events granted full compromise.",
          projOverview:
            "Weak authentication practices and overly permissive privileges allowed the leverage to springboard into full system compromise.",
          projClient: "Active Directory, Windows",
          projSpecial: "TryHackMe Lab",
          projStory:
            "In this gray box assessment, initial Active Directory enumeration revealed exposed credentials, password reuse, and excessive account permissions that created a viable path to domain compromise. Analysis of domain relationships identified Resource-Based Constrained Delegation as an exploitable attack path. By creating a machine account and abusing delegated permissions, I obtained the required Kerberos service tickets and authenticated to the domain controller with elevated privileges.",
          projRole: "Cybersecurity Consulant",
          projDuty:
            "Enumeration, Vulnerability Assessment, Exploitation, Remediation Research, Report writing.",
          projHeroImage: "Forwardbloodhoundmap.png",
          projImages: [
            "Forwardbloodhoundmap.png",
            "ForwardNTAuth.png",
            "Forwardpolicy.png",
          ],
          projDocuments: [
            {
              title: "Forward Pentest Report",
              type: "PDF",
              url: "/docs/Forwardreport.pdf",
            },
          ],
          projAwards: ["Cyber Award A", "Award B"],
        },
      ],
    },
    // ADVERTISING DATA OBJECT
    advertising: {
      colorClass: "advert-accent",
      // mainHeaderText: ["I BUILD CREATIVE IDEAS", "AROUND BUSINESS GOALS"],
      mainHeaderText: [
        {
          text: "I BUILD",
          emphasized: false,
        },
        {
          text: "CAMPAIGNS",
          emphasized: true,
        },
        {
          text: " FOR BUSINESS GROWTH.",
          emphasized: false,
        },
      ],

      headerImage: {
        src: "Adpolished1.webp",
        alt: "Valentino Lloyd — Advertising",
      },
      mainHeaderSubtext:
        "I lead teams in developing creative concepts and campaigns that connect with culture, build brand equity, and advance our clients’ business objectives.",

      accentImage: {
        src: "sector-accents/AdvertisingAccent.svg",
        alt: "Bullseye.webp",
      },
      bumperText: [
        "A product may be functionally superior, but that alone does not make it meaningful.",
        " How people perceive it, connect with it, and understand its value should shape every expression of the brand.",
      ],
      contactContent: {
        contactHook: [
          "I THINK I CAN HELP WITH THAT",
          "Let's Build A Brand Experience People Remember And Trust",
        ],
        contactHeader:
          "Bring me the business goal, and together we can shape the creative idea that moves it forward.",
        contactDescription:
          "Have a project you want to collaborate on? Lets chat.",
      },
      projects: [
        // PROJECT 1
        {
          projName: "Chase the Sun",
          projHeadline:
            "The race to a world class sporting event from Paradise to Paris.",
          projOverview:
            "With fewer than three months remaining before the World Athletics Relays arrived in The Bahamas, event organizers needed to strengthen the brand, build public excitement, and drive attendance. Blue Orchid developed and delivered “Chase the Sun: From Paradise to Paris”—a campaign that connected the energy of The Bahamas with the athletes’ journey toward the Paris Olympics.",
          projClient:
            "Ministry of Youth, Sports and Culture / IAAF World Athletics Relays",
          projStory: `
    My team was approached by key officials from the Ministry of Youth, Sports and Culture and the international governing body for the World Athletics Relays. With fewer than three months before the event, the engagement required the agency to rapidly mobilize to develop a campaign and strategy that would strengthen the event’s branding, and generate sales to fill the 17,000-seat stadium. This event was the final qualifying opportunity for athletes to secure their place in the Paris Olympics, and the campaign needed to communicate that magnitude and excitement while also celebrating the energy, culture, and beauty of The Bahamas.

    As Managing Partner, I guided the engagement from its earliest discussions. I led the initial client courtship and onboarding, developing the project scope, managing the commercial and financial negotiations, and subsequently serving as the principal liaison between the agency, the client, and external stakeholders.

    Im my capacity asProject Director, I coordinated the agency’s internal strategy, creative, production and account functions to keep the work in scope, on schedule, and aligned with the quality expected by an international sporting event. This required managing numerous stakeholder requests and frequently shifting priorities while protecting the integrity of the campaign strategy and keeping critical deliverables moving forward.

    As a part of that portfolio, I led the production of key photo and video assets for local marketing and strategic communications, as well as directed the development of key content pieces used for international promotions. A notable challenge here was maintaining creative quality whilst working within compressed production and approval timelines.

    Within a 2 month period, the resulting campaign, “Chase the Sun: From Paradise to Paris,” reached millions of people globally, and generated over 70,000 clicks, and helped fill the 17,000-seat stadium for a historic event.
  `,

          projRole:
            "Managing Partner and Project Director, with responsibility for digital media production.",
          projDuty: `Scope & Contract Development  |  Client Relations  |  Project Leadership  |  Media Production`,
          projHeroImage: "wrschacthumb.webp",
          projImages: ["WRShacari.webp", "WRJunkanoo.webp", "WRFemke.webp"],
          projAwards: [],
        },
        // PROJECT 2
        // PROJECT 2
        {
          projName: "L/nk Up with BTC",
          projHeadline:
            "Repositioning a national telecommunications company for stronger, faster connection.",
          projOverview:
            "Preparing for a transition in corporate leadership, the launch of a major new product, and a new chapter for the brand, BTC needed an identity that reflected its renewed commitment to innovation and customer experience. The resulting rebrand was introduced through a vibrant, culturally attuned campaign built around how Bahamians connect, helping BTC separate itself from outdated perceptions and reassert its position in an increasingly competitive telecommunications market.",
          projClient: "Bahamas Telecommunications Company",
          projStory: `
Although BTC was one of The Bahamas’ most established brands, aging infrastructure and negative customer experiences had contributed to declining trust and the perception that the company was out of step with an evolving market. Operational and infrastructural improvements were already underway, but rebuilding the brand—and public confidence in it would require more than a new product offering. With approximately 12 weeks remaining before the launch of BTC’s new fibre internet service, we were engaged to help develop a new brand identity and the creative architecture for a series of strategic, product-focused campaigns.

As Managing Partner and client relations lead, I guided the engagement across a layered network of corporate and external stakeholders. Establishing strong working relationships, maintaining clarity around responsibilities, and keeping decision-makers aligned were essential to moving an undertaking of this scale forward within the compressed timeline.

Working alongside the Creative Director, I also served as Art Director and production lead, helping to shape a layered creative platform grounded in Bahamian culture and real customer experiences. I curated and produced a series of hero assets that introduced the new identity across traditional and digital media.

The launch of the campaign gave BTC a more vibrant and culturally relevant presence at a pivotal moment for the company. The repositioning helped reverse declines across existing lines of business while supporting the successful entry of its fibre internet offering into the market. The rebrand also received a 2023 MUSE Gold Award for Corporate Identity Redesign.
  `,
          projRole:
            "Managing Partner and Account Director, providing valuation, client relation leadership, art direction, and collaborative creative direction.",

          projDuty: `Scope Development  |  Art Direction  |  Creative Production  |  `,
          projHeroImage: "btchero.webp",
          projImages: [
            "btccreators.webp",
            "btcninjas.webp",
            "btcmashup.webp",

            "btcbingers.webp",
          ],
          projAwards: [
            {
              awardname: "Muse Award - Gold Winner",
              category: "Corporate Identity Design",
              campaign: "L/nk Up",
              client: "Bahamas Telecommunicatons Company",
              year: "2023",
              role: "Account Director & Project Lead",
              org: " Muse Creative Award",
              orgsite: "https://museaward.com/",
              badgeimage: "MuseGold.webp",
              certlink: "https://museaward.com/winner-info.php?id=226211",
            },
          ],
        },

        // PROJECT 3
        // PROJECT 3
        {
          projName: "Essential to Wealth Security",
          projHeadline:
            "Repositioning a national financial sector for a changing global audience.",
          projOverview:
            "The Bahamas Financial Services Board needed a brand capable of serving two connected audiences: a diverse local financial-services sector and the international clients, partners, and investors it seeks to reach. Working closely with BFSB leadership and industry stakeholders, we developed a unified brand platform that presents The Bahamas as a progressive, sophisticated, and trusted international financial centre.",
          projClient: "Bahamas Financial Services Board",

          projStory: ` The Bahamas Financial Services Board serves as both a unifying voice for the country’s financial-services sector and an international ambassador for the jurisdiction. Its brand therefore needed to resonate with a diverse local membership while presenting The Bahamas as a progressive, sophisticated, and trusted financial centre. As Managing Partner and Project Director, I led the client engagement through scoping,negotiations, and onboarding, and subsequently guided the creative team in developing a brand system that could serve both audiences.
          
          A central part of my contribution was bridging the client’s institutional priorities with the creative team’s ambition. In this instance I was able to help BFSB’s leadership have broader perspective on our work served their strategy for sector development and international growth. At the same time, I translated the client’s operational context and priorities into creative direction, helping our team develop a tailored brand system that could support industry engagement, thought leadership, global marketing, and international conferences. `,
          projRole:
            "Managing Partner and Project Director, providing art direction and collaborative creative leadership.",
          projDuty: `Scope & Contract Development  |  Client Relations  |  Project Leadership  `,
          projHeroImage: "BFSBweb.webp",

          projImages: [
            "BFSBweb.webp",
            "bfsbtour.webp",
            "bfsbheader.webp",
            "bfsbschedule.webp",
            "bfsbday.webp",
          ],
          projAwards: [],
        },

        // PROJECT 4
        // PROJECT 4
        {
          projName: "Cloud Bahamas",
          projHeadline:
            "Building adoption for a government-wide digital transformation.",
          projOverview:
            "Cloud Bahamas was created to modernize financial and human-resource processes across the Bahamian public service. Following a limited soft rollout, the platform required a clearer identity, stronger messaging, and an integrated communications strategy capable of building confidence among civil servants while demonstrating its wider national value.",
          projClient: "Government of The Bahamas",
          projStory: `
    Cloud Bahamas had been introduced through a soft rollout, but its identity overlapped with other government technology initiatives, its purpose was not clearly understood, and adoption among public servants remained low. These challenges were compounded by a complex stakeholder environment and scepticism from some parts of the public sector. With two months remaining before the platform’s formal launch, the government engaged our team to clarify the brand, strengthen its communications, and help civil servants understand the platform as a long awaited improvement to their working lives.

    As business and client relations lead, I guided   the team and client through identifying and untangling the platform’s many stakeholder groups. I then led our team in developing a cohesive strategy that connected internal communications, external public relations, marketing, and advertising—ensuring that each workstream reinforced the same overarching narrative while responding to the needs of its particular audience. I also led digital media production and helped shape the events and activation strategy. Within the first few weeks of the campaign launch, internal adoption increased by more than 30%. Although the full campaign was subsequently curtailed following a shift in the client’s priorities, its early performance demonstrated the value of a clear, audience-specific, and integrated communications approach.
  `,

          projRole:
            "Managing Partner and Project Director, with responsibility for client leadership, art direction, and production oversight.",
          projDuty:
            " Scope Development  | Client Relations |Media Production |  Art Direction |  Creative Strategy",
          projHeroImage: "cloudcta.webp",
          projImages: [
            "cloudboard2.webp",
            "cloudretro.webp",
            "cloudbird.webp",
            "cloudcta.webp",
            "cloudsplit.webp",
            "cloudbike.webp",
          ],
          projAwards: [],
        },
        // PROJECT 5
        // PROJECT 5
        {
          projName: "Kalik- Who Are We",
          projHeadline:
            "Reimagining Junkanoo as a cultural hero and Kalik as a champion of its story.",
          projOverview:
            "Kalik set out to celebrate Junkanoo in a way that went beyond its spectacle and entertainment value. Through culturally informed research, a distinctive campaign language, and a 40 minute documentary shown in Bahamian cinemas, “Who Are We” presented Junkanoo as a living expression of heritage, community, and national identity.",
          projClient: "Kalik (by Heineken)",
          projStory: `
    Junkanoo is more than a spectacle; for many Bahamians, it is heritage, community, identity, and a way of life. “Who Are We” marked the first time a major brand committed to celebrating and contributing to the growth of the culture at this scale. As Partner and Art Director, I worked alongside the Creative Director to lead the campaign’s creative development and cultural research. I also identified and engaged consultants with deep roots in the Junkanoo community, ensuring that the work was informed by the people who understood and lived the culture.

    Our creative challenge was to present an already spectacular tradition in a way that moved beyond its entertainment value while remaining subtly connected to Kalik’s identity as the Beer of The Bahamas. We developed a visual language that portrayed Junkanoo with the scale and mythology of an ancient cultural hero. As Art Director and Producer, I led the development of the campaign assets and served as Producer and Director of the 30-minute “Who Are We” documentary shown in Bahamian cinemas. I assembled the production team, curated talent and contributors, helped lead the writing process, and guided the production and client teams from script development through final cut. The campaign generated more than 3.7 million impressions 393,000 video views, 380,000 engagements, 144,000 cans sold in two months, and 30% volume growth during the campaign period.
  `,
          projRole:
            "Partner and Art Director; Producer and Director of the “Who Are We” documentary.",
          projDuty:
            "Art Direction  |  Creative Development  |  Cultural Curation  |  Film Direction",
          projHeroImage: "wawmalegroupintense.webp",
          projImages: [
            "wawcansbanner.webp",
            "waweternalflame.webp",
            "wawsocial1.webp",
            "wawsocial3.webp",
            "wawmalegroupintense.webp",
            "wawbottlesbanner.webp",
          ],
          projAwards: [],
        },

        // PROJECT 6
        // PROJECT 6
        {
          projName: "Marina Living, Perfected",
          projHeadline:
            "Birthing a luxury brand world where urban living meets life at sea.",
          projOverview:
            "Hurricane Hole Marina needed a brand story that could honour its established legacy while appealing to a new generation of affluent residents and yacht owners. By combining the freedom of marina life with the energy and convenience of an urban destination, we created an aspirational platform for the development’s initial sales and marketing efforts.",
          projClient: "Sterling Global Developments",
          projStory: `
    Hurricane Hole Marina carried an established legacy that the client wanted to preserve while repositioning the development for a new generation of affluent residents and yacht owners. As Partner, Art Director, and Producer, I worked alongside the Creative Director to curate the client’s experience throughout the ideation and brand development process. Because the client team naturally approached the project through a commercial and investment lens, it was important to make the creative process tangible and inclusive, helping them understand the strategic value of the direction and become genuinely invested in its outcome.

    As Art Director, I helped define the scenes, environments, styling, and visual details that would bring the brand world to life. Producing the campaign required coordinating international talent, yachts, locations, wardrobe, and an international stylist, each introducing its own creative and logistical demands. I also co-directed the lifestyle shoot, ensuring that every element expressed the meeting of marina life, urban convenience, and understated luxury. The resulting imagery became a foundational component of Hurricane Hole’s initial sales and marketing materials, helping establish the premium visual platform that supported its early market positioning and evolution into one of The Bahamas’ premier marina destinations.
  `,
          projRole:
            "Partner, Art Director and Producer, with responsibility for project valuation and scope development, as well as project management.",

          projDuty: `Scope Development  |  Art Direction  |  Creative Production  |  Shoot Direction`,
          projHeroImage: "HHreaching.webp",
          projImages: [
            "HHcouplewalk.webp",
            "HHgirlsday.webp",
            "HHreaching.webp",
            "HHkiteflip.webp",
          ],
          projAwards: [],
        },
      ],
    },
    // WEB DATA OBJECT
    web: {
      colorClass: "web-accent",
      // mainHeaderText: ["I BUILD WEB", "ASSETS THAT WORK"],
      mainHeaderText: ["I BUILD WEB", "ASSETS THAT WORK"],
      mainHeaderText: [
        {
          text: "I BUILD",
          emphasized: false,
        },
        {
          text: "WEB ASSETS ",
          emphasized: true,
        },
        {
          text: "THAT WORK.",
          emphasized: false,
        },
      ],
      headerImage: {
        src: "Webadj.webp",
        alt: "Valentino Lloyd — WebDev",
      },
      mainHeaderSubtext:
        "As a front-end web developer, I work at the intersection of creativity, functionality, and technology—combining thoughtful interface design with front-end development to create responsive, intuitive, and useful digital tools and experiences.",
      accentImage: { src: "sector-accents/WebAccent.svg", alt: "logo" },
      bumperText: [
        "Web based technology continues to transform how people live, work, and connect. For businesses and economies alike,  ",
        "using it effectively is no longer optional; it is fundamental to innovation, growth, and competitiveness.",
      ],
      contactContent: {
        contactHook: [
          "I THINK I CAN HELP",
          "Let's Build A Tool That Works For People and Business.",
        ],
        contactHeader: "CONNECT WITH ME",
        contactDescription:
          "Have an idea to build or a digital experience that could work better? Let’s make it useful, intuitive, and effective.",
      },
      projects: [
        {
          projName: "Web Project 1",
          projHeadline: "Headline",
          projOverview:
            "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Dolorum in, natus sed adipisci harum officiis.",
          projClient: "Web1 Company Ltd",
          projStory: "Awesome Story on how this ccame to be",
          projRole: "Art Director",
          projDuty: "Project Management, UI Design, Developer",
          projImages: ["web1.webp", "web2.webp"],
          projAwards: [],
        },
        {
          projName: "Web Project 2",
          projHeadline: "Headline",
          projOverview:
            "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Dolorum in, natus sed adipisci harum officiis.",
          projClient: "Web2 Company Ltd",
          projStory: "Awesome Story on how this ccame to be",
          projRole: "Art Director",
          projDuty: "Project Management, UI Design, Developer",
          projImages: ["web3.webp", "web4.webp"],
          projAwards: [],
        },

        {
          projName: "Web Project 3",
          projHeadline: "Headline",
          projOverview:
            "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Dolorum in, natus sed adipisci harum officiis.",
          projClient: "Web2 Company Ltd",
          projStory: "Awesome Story on how this ccame to be",
          projRole: "Art Director",
          projDuty: "Project Management, UI Design, Developer",
          projImages: ["web5.webp", "web1.webp"],
          projAwards: [],
        },
      ],
    },
  };

  const certData = [
    {
      name: "PNPT -Practical Network Penetration Tester PNPT",
      year: "2026",
      org: "TCM Security",
      orgsite: "https://tcm-sec.com/academy/",
      badgeimage: "pnptbadge.webp",
      badgelink:
        "https://api.accredible.com/v1/frontend/credential_website_embed_image/badge/175134964",
      certimage: "",
      certlink:
        "https://api.accredible.com/v1/frontend/credential_website_embed_image/certificate/175134964",
      // credlylink:
      //   "https://certified.tcm-sec.com/9cd8c1e6-b445-4ed4-ab44-7f52b94b6f3c#acc.DVulOaqs",
    },
    {
      name: "CompTIA Security+",
      year: "2024",
      org: "CompTIA",
      orgsite: "https://www.comptia.org/en/",
      badgeimage: "Security+-png.png",
      badgelink:
        "https://www.credly.com/badges/be3083aa-4f0c-4841-a5db-0962e7082cab/public_url",
      certimage: "",
      certlink:
        "https://www.credly.com/badges/be3083aa-4f0c-4841-a5db-0962e7082cab/public_url",
    },

    {
      name: "Javascript Algorithms and Data Structures",
      year: "2021",
      org: "freeCodeCamp",
      orgsite: "https://www.freecodecamp.org",
      badgeimage: "fcc_primary_small.webp",
      badgelink: "",
      certimage: "fccjavascript.webp",
      certlink:
        "https://www.freecodecamp.org/certification/code%20conch/javascript-algorithms-and-data-structures",
    },
    {
      name: "Responsive Web Design",
      year: "2020",
      org: "freeCodeCamp",
      orgsite: "https://www.freecodecamp.org",
      badgeimage: "fcc_primary_small.webp",
      badgelink: "",
      certimage: "fccweb.webp",
      certlink:
        "https://www.freecodecamp.org/certification/code%20conch/responsive-web-design",
    },
  ];

  const awardData = [
    {
      awardname: "Muse Award - Gold Winner",
      category: "Corporate Identity Design",
      campaign: "L/nk Up",
      client: "Bahamas Telecommunicatons Company",
      year: "2023",
      role: "Art Director & Producer",
      org: " Muse Creative Award",
      orgsite: "https://museaward.com/",
      badgeimage: "MuseGold.webp",
      certlink: "https://museaward.com/winner-info.php?id=226211",
    },

    {
      awardname: "Muse Award - Gold Winner",
      category: "Social Media Stunt",
      campaign: "Kalik Radler - So Refreshing",
      client: "Kalik (by Heineken)",
      year: "2020",
      role: "Art Director & Producer",
      org: " Muse Creative Award",
      orgsite: "https://museaward.com/",
      badgeimage: "MuseGold.webp",
      certlink: "https://museaward.com/winner-info.php?id=3557",
    },

    {
      awardname: "Shorty Award - Finalist ",
      category: "Social Good",
      campaign: "Toward A Plastic Free Bahamas",
      client: "Ministry of Environmental Health",
      year: "2020",
      role: "Art Director & Producer",
      org: " Shorty Awards",
      orgsite: "https://shortyawards.com/",
      badgeimage: "ShortyFinalist.webp",
      certlink:
        "https://shortyawards.com/5th-socialgood/towards-a-plastic-free-bahamas",
    },

    {
      awardname: "SIA- Platinum Winner",
      category: "Marketing Effectiveness",
      campaign: "Get Money Smart",
      client: "Central Bank of The Bahamas",
      year: "2018",
      role: "Art Director & Producer",
      org: "Summit International Awards",
      orgsite: "https://www.summitawards.com/",
      badgeimage: "SIA-Award-Logo.png",
      certlink:
        "https://ewnews.com/blue-orchid-brings-it-home-with-three-international-marketing-industry-awards/",
    },

    {
      awardname: "Summit International Awards - Emerging Leader",
      category: "Social Media Marketing Campaign",
      campaign: "Bahamas At Heart",
      client: "Atlantis Paradise Island",
      year: "2018",
      role: "Art Director & Producer",
      org: "Summit International Awards",
      orgsite: "https://www.summitawards.com/",
      badgeimage: "SIA-Award-Logo.png",
      certlink:
        "https://ewnews.com/blue-orchid-brings-it-home-with-three-international-marketing-industry-awards/",
    },

    {
      awardname: "AAA Addy Award (CAF) - Silver Winner",
      category: "Best Social Media Campaign",
      campaign: "How We K'lik",
      client: "Kalik (by Heineken)",
      year: "2017",
      role: "Art Director & Producer",
      org: "Caribbean Advertising Federation (ADDY) Awards",
      orgsite: "https://www.americanadvertisingawards.com/",
      badgeimage: "silveraddy2.webp",
      certlink: "",
    },

    {
      awardname: "Travel Weekly Magellan Award- Gold Winner",
      category: "Best Social Media Campaign",
      campaign: "Baha Mar Dream Team",
      client: "",
      year: "2014",
      role: "Co-Creator & Producer",
      org: "Travel Weekly",
      orgsite: "https://www.travelweeklyawards.com/",
      badgeimage: "magellanround.webp",
      certlink:
        "https://www.thebahamasinvestor.com/2014/baha-mar-media-campaign-wins-award/",
    },
  ];

  const [selectedProject, setSelectedProject] = useState(
    sectorData.cyber.projects[0],
  );

  const activeSector = sectorData[selectedSector]; //Returns the sectorData based on the selectedSector.

  const runViewTransition = (callback) => {
    if (
      typeof document !== "undefined" &&
      typeof document.startViewTransition === "function"
    ) {
      document.startViewTransition(() => {
        // React may otherwise defer the state update until after the
        // browser has already captured the transition snapshot.
        flushSync(callback);
      });
      return;
    }

    callback();
  };

  // Used for smooth transition between sectors.
  const changeSector = (sectorKey) => {
    if (!sectorData[sectorKey]) return;

    const updateSector = () => {
      setSelectedSector(sectorKey);
      setSelectedProject(sectorData[sectorKey].projects[0]);
    };

    runViewTransition(updateSector);
  };

  const openProject = (project) => {
    if (!project) return;
    setSelectedProject(project);
  };

  const inquiryData = {
    name: "",
    email: "",
    phone: "",
    budget: "",
    message: "",
  };
  const [formData, setFormData] = useState(inquiryData);

  const value = {
    certData,
    awardData,
    sectorData,
    selectedSector,
    activeSector,
    changeSector,
    selectedProject,
    setSelectedProject,
    openProject,
    formData,
    setFormData,
  };

  return (
    <SectorContext.Provider value={value}>{children}</SectorContext.Provider>
  );
}

export function useSector() {
  const context = useContext(SectorContext);

  if (!context) {
    throw new Error("useSector must be used inside SectorProvider");
  }

  return context;
}
